export const PRODUCT_BASE = '/materialHandling';
export const PRODUCTS_HASH = '/#materialHandling';

export const categorySegment = (category) =>
  String(category || '').replace(/\s+/g, '');

export const productPath = (product) =>
  `${PRODUCT_BASE}/${categorySegment(product.category)}/${product.name}`;

export const findProductByRoute = (products, { category, productName, slug } = {}) => {
  if (category && productName) {
    const decodedCategory = decodeURIComponent(category);
    const decodedName = decodeURIComponent(productName).replace(/\+/g, ' ').trim();
    return products.find((p) => {
      const sameCategory =
        categorySegment(p.category).toLowerCase() === decodedCategory.toLowerCase();
      if (!sameCategory) return false;
      const name = p.name.toLowerCase();
      const legacyName = `${p.name} ${p.category}`.toLowerCase();
      return decodedName.toLowerCase() === name || decodedName.toLowerCase() === legacyName;
    });
  }

  if (slug) {
    const decoded = decodeURIComponent(slug).toLowerCase();
    return products.find((p) => p.name.toLowerCase() === decoded);
  }

  return undefined;
};
